import { render, staticRenderFns } from "./OpinionFamilyListTab.vue?vue&type=template&id=0a3b7c49&scoped=true&lang=pug"
import script from "./OpinionFamilyListTab.vue?vue&type=script&lang=ts"
export * from "./OpinionFamilyListTab.vue?vue&type=script&lang=ts"
import style0 from "./OpinionFamilyListTab.vue?vue&type=style&index=0&id=0a3b7c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b7c49",
  null
  
)

export default component.exports